import styles from "./header.module.scss";
import { ColumnContext } from "./column-context";
import React, { createContext, useRef } from "react";
import { Header } from "./header";
import { useTable } from "./table-context";

type TableHeaderContextProps = {
  height: number;
};
export const TableHeaderContext = createContext<
  TableHeaderContextProps | undefined
>(undefined);

export const TableHeader = () => {
  const { mergedHeaderGroups } = useTable();

  const ref = useRef<HTMLTableSectionElement>(null);

  return (
    <thead className={styles.header} ref={ref}>
      <TableHeaderContext.Provider
        value={{ height: ref.current?.clientHeight ?? 0 }}
      >
        {mergedHeaderGroups.map((headerGroup, groupIndex) => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map((header, index) => (
              <ColumnContext.Provider
                key={index}
                value={{
                  id: header.column.id,
                  depth: headerGroup.depth,
                }}
              >
                <Header
                  header={header}
                  headerGroup={headerGroup}
                  index={index}
                />
              </ColumnContext.Provider>
            ))}
          </tr>
        ))}
      </TableHeaderContext.Provider>
    </thead>
  );
};
